import React, { FunctionComponent } from 'react'
import YouTube from 'react-youtube'
import styled from 'styled-components'

const Outer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;
  @media (max-width: 40rem){
    margin-top: 0;
  }
  & > * {
    width: 100%;
    display: block;
  }
  iframe {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }
`

const Item = styled.div``

const Label = styled.div`
  margin-top: 1rem;
  text-align: center;
  font-weight: 700;
`

type YoutubeSectionProps = {

}
export const YoutubeSection: FunctionComponent<YoutubeSectionProps> = () => {
  return <Outer>
    <Item>
      <YouTube videoId='pfRcbTTMFuM' />
      <Label>就職した理由は？【ムロノキッズ 新人座談会】</Label>
    </Item>
    <Item>
      <YouTube videoId='Feg4SZ4Bj2Q' />
      <Label>ムロノキッズのココが好き！【ムロノキッズ ベテラン・若手座談会】</Label>
    </Item>
  </Outer>
}